import BasePage from '@/found/components/table_page';

export default {
  name: 'department_receiving_detail_list',
  extends: BasePage,
  data() {
    return {
      params: {
        actType: 'department_receive',
      },
    };
  },
  components: {

  },
  async created() {
    await this.getConfigList('department_receiving_detail_list');
  },
  methods: {

  },
};
